import { useEffect, useState } from 'react';
import { Typography, Tooltip, useMediaQuery, useTheme } from '@mui/material';

export default function CurrentTime({
  locale = undefined,
}: {
  locale?: string | string[];
}) {
  const [now, setNow] = useState(() => new Date());
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  const timeFormatted = now.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const dateFormatted = now.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Tooltip
      title={dateFormatted}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      placement="bottom"
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'primary.main',
            fontSize: isMobile ? '0.75rem' : '0.875rem',
            px: isMobile ? 1.5 : 2,
            py: isMobile ? 0.75 : 1,
          }
        }
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{
          fontFamily: 'monospace',
          cursor: 'help',
          userSelect: 'none',
          '&:hover': {
            color: 'primary.main',
            transition: 'color 0.2s ease-in-out'
          }
        }}
      >
        {timeFormatted}
      </Typography>
    </Tooltip>
  );
}
